<template>
  <section>
    <v-layout
      column
      wrap
      class="my-5"
      align-center
    >
      <v-flex xs12 sm4 class="my-3">
        <div class="text-xs-center">
          <h2 class="headline">projekty i realizacje</h2>
        </div>
      </v-flex>
      <v-container grid-list-xl>
        <v-layout row wrap align-center>
          <v-flex xs12 md4 v-for="item in projects" :key="item.url">
            <ProjectsListElement :imgSrc="item.imgSrc" :title="item.title" :url="item.url"></ProjectsListElement>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </section>
</template>

<script>
import ProjectsListElement from "./ProjectsListElement.vue";
import ProjectRepository from '../services/ProjectRepository';

const projectRepository = new ProjectRepository();

export default {
  components: {
    ProjectsListElement,
  },
  data() {
    return {
      projects: projectRepository.getProjects()
    }
  }
}
</script>

